<template>
  <FormModal
    :visible="showModalCreate"
    title="Tipos de investidores"
    :hide-footer="true"
    width="600px"
    @update:visible="closeModal"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <svg
          class="w-10 h-10 text-blue-600 dark:text-blue-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Tipos de investidores
        </h2>
      </div>
    </template>

    <template #default>
      <div class="space-y-6">
        <!-- Investidor Qualificado -->
        <div
          class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-gray-50 dark:bg-slate-800"
        >
          <h3
            class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2"
          >
            Investidor Qualificado
          </h3>
          <p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
            Declaro que possuo mais de R$ 1 milhão investidos em aplicações
            financeiras ou possuo certificações específicas do mercado
            financeiro.
          </p>
        </div>

        <!-- Investidor Profissional -->
        <div
          class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-gray-50 dark:bg-slate-800"
        >
          <h3
            class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2"
          >
            Investidor Profissional
          </h3>
          <p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
            Declaro que possuo mais de R$ 10 milhões investidos em aplicações
            financeiras ou sou participante do mercado financeiro com atuação
            profissional.
          </p>
        </div>

        <!-- Investidor em Geral -->
        <div
          class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-gray-50 dark:bg-slate-800"
        >
          <h3
            class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2"
          >
            Investidor em Geral
          </h3>
          <p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
            Declaro que não me enquadro nas classificações acima.
          </p>
        </div>

        <!-- Botão de ação -->
        <div class="flex justify-center pt-2">
          <button
            @click="closeModal"
            class="px-8 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
          >
            Entendi
          </button>
        </div>
      </div>
    </template>
  </FormModal>
</template>

<script>
import { mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";

export default {
  components: {
    FormModal,
  },
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_INVESTIDOR_INFORMATIVO",
      user: "auth/user",
    }),
  },
  methods: {
    closeModal() {
      this.$store.commit("SET_MODAL_INVESTIDOR_INFORMATIVO", false);
    },
  },
};
</script>

<style scoped>
/* Estilos customizados para o conteúdo dos cards */
:deep(.border) {
  font-size: 0.875rem;
  line-height: 1.5;
}
</style>
